import {Button} from "@zendeskgarden/react-buttons";
import {ReactElement} from "react";
import {AiOutlineLogout} from "react-icons/ai";
import * as css from "../settings-nav-menu/styles/css.module.scss";
import {useLogoutConfirmation} from "./useLogoutConfirmation";

export function LogoutButton(): ReactElement {
    const {requestLogout, logoutConfirmation} = useLogoutConfirmation();

    return (
        <>
            <Button isBasic className={css.logoutButton} onClick={requestLogout}>
                <AiOutlineLogout size={22} className={css.logoutButtonIcon} />
                Logout
            </Button>
            {logoutConfirmation}
        </>
    );
}
